import { isAxiosError } from 'axios';
import { HttpError, ValidationError } from '@core/errors/AppError';

export const toAppError = (error: unknown): Error => {
  if (isAxiosError(error)) {
    const status = error.response?.status ?? 0;
    const data = error.response?.data as
      { message?: string; errors?: Record<string, string[]> } | undefined;

    if (status === 422 && data?.errors) {
      return new ValidationError(data.errors);
    }

    return new HttpError(data?.message ?? error.message, status, data?.errors);
  }

  return error instanceof Error ? error : new Error('Unknown error');
};
